export { default } from "./SponsorPreAdv";
